/* eslint-disable no-undef */
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';

import './index.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import * as serviceWorker from './serviceWorker';
import configureStore from './store';
import LoadingScreen from './components/Loading/LoadingScreen';
import './i18n';
import { cleanConsole } from './utils/cleanConsole';

const { store, persistor } = configureStore();

cleanConsole(false);

ReactDOM.render(
  <Suspense fallback={<LoadingScreen />}>
    <Provider store={store}>
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
        {/* <React.StrictMode> */}
        <HelmetProvider>
            <App />
        </HelmetProvider>
        {/* </React.StrictMode> */}
      </PersistGate>
    </Provider>
  </Suspense>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
